<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'DOutsideLinkEditor',
  extends: compoment
}
</script>
